import { Helmet } from "react-helmet-async";
import { publishPageMeta } from "@/lib/pageMetaStore";

type PageMetaProps = {
  title: string;
  description: string;
  /** Soft cap for title length (default 60). Company pages historically used 70. */
  titleMaxLength?: number;
};

/**
 * Sets document title + description at render time (SSR/prerender + client).
 * Also publishes into pageMetaStore so SiteSchema can read values in the same pass.
 */
export const PageMeta = ({ title, description, titleMaxLength = 60 }: PageMetaProps) => {
  const safeTitle = title.slice(0, titleMaxLength);
  const safeDescription = description.slice(0, 160);
  publishPageMeta(safeTitle, safeDescription);

  return (
    <Helmet>
      <title>{safeTitle}</title>
      <meta name="description" content={safeDescription} />
    </Helmet>
  );
};
